import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DropoutDialogData {
    title: string;
    text: string;
}

@Component({
    selector: 'app-dropout-dialog',
    templateUrl: './dropout-dialog.component.html',
    styleUrls: ['./dropout-dialog.component.scss'],
})
export class DropoutDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: DropoutDialogData) {}
}
